import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "header_title fs24" }, "担当者設定", -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "fs16 fw600 mt40" }, "割当設定", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "mt10" }, "担当者を割り当てるルールを設定できます。", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "w100 mt20",
  style: {"padding":"10px 20px"}
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "mt10 alertRed" }, " こちらは調整カレンダーの設定になります。変更しましたら、必ず「調整カレンダーを更新」ボタンから更新してください。 ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h4", { class: "fl" }, "割り当て比率の設定", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "mt10" }, "割り当て比率 (0~100) ※0だと提案されません。", -1)
const _hoisted_15 = { class: "fl mr20" }
const _hoisted_16 = { class: "circleBlueButton selected fl centered whiteColor pad5 fs16 mt5 mr10" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_20 = { class: "mt20" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "fs16 fw600 mt40" }, "プロフィールの表示", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "mt10" }, "プロフィールを表示するタイミングを設定できます。", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!

  return (_ctx.Util.isPresent(_ctx.rcm.astag.meeting_attendees_groups))
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: _normalizeClass(`rad8 kakugo calendarfirst with_white_bg ofs ${_ctx.isSP ? 'pad20' : 'pad20'}`)
      }, [
        _hoisted_1,
        (_ctx.rcm.astag.meeting_attendees_groups.length > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _hoisted_4,
              _createElementVNode("div", null, [
                ([`equal`, `priority`].includes(_ctx.magRuleOption))
                  ? (_openBlock(), _createBlock(_component_SelectTag, {
                      key: 0,
                      class: "fl fs14 roundForm",
                      style: {"min-width":"30px","height":"50px"},
                      options: _ctx.SelectUtil.periodDaysForAssignOptions.map(mt => mt.name),
                      optionName: `period_days_for_assign`,
                      defaultOption: _ctx.getDefaultPeriodDaysForAssignName(),
                      onSelectValue: _ctx.selectPeriodDaysForAssign
                    }, null, 8, ["options", "defaultOption", "onSelectValue"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_SelectTag, {
                  class: "fl fs14 roundForm",
                  style: {"min-width":"330px","height":"50px"},
                  options: _ctx.SelectUtil.assignMagRuleOptions.map(mt => mt.name),
                  optionName: `assign_mag_rule`,
                  defaultOption: _ctx.getDefaultAssignMagRuleName(),
                  onSelectValue: _ctx.selectAssignMagRule
                }, null, 8, ["options", "defaultOption", "onSelectValue"])
              ]),
              _hoisted_5,
              _createElementVNode("div", null, [
                ([`priority`, `priority_by_this_month`].includes(_ctx.rcm.room_setting.assign_mag_rule))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      (_ctx.from == `room_settings`)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_11))
                        : _createCommentVNode("", true),
                      _hoisted_12,
                      (_ctx.from == `room_settings` && _ctx.showSaveAstagButton)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "fr skyblueBg rad5 mt10 fs11 pointer hoverGreyBg pad10 fw600",
                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.saveAstag && _ctx.saveAstag(...args)))
                          }, " 調整カレンダーを更新 "))
                        : _createCommentVNode("", true),
                      _hoisted_13,
                      _hoisted_14,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rcm.astag.meeting_attendees_groups, (mag) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "fl",
                          key: mag.id
                        }, [
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, _toDisplayString(mag.name), 1),
                            _createVNode(_component_MdTextfieldTag, {
                              style: {"height":"56px","min-width":"80px"},
                              fieldStyle: "min-width:80px;",
                              class: "fl fs14 mb5",
                              type: `number`,
                              min: 0,
                              max: 100,
                              value: mag.priority,
                              retValue: mag.id,
                              onInputValue: _ctx.inputPriority
                            }, null, 8, ["value", "retValue", "onInputValue"]),
                            _hoisted_17
                          ])
                        ]))
                      }), 128)),
                      _hoisted_18
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_19
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _hoisted_22,
          _createVNode(_component_SelectTag, {
            name: "meeting_days_end",
            id: "select_mags_control",
            class: "fl fs14 roundForm",
            style: {"min-width":"30px","height":"50px"},
            options: _ctx.SelectUtil.selectMagType.map(mt => mt.name),
            defaultOption: _ctx.getDefaultMagTypeName(),
            onSelectValue: _ctx.inputMagType,
            isDisabled: false
          }, null, 8, ["options", "defaultOption", "onSelectValue"]),
          _hoisted_23
        ])
      ], 2))
    : _createCommentVNode("", true)
}